import { GetterTree } from 'vuex'
import { ExamState } from './types'
import { RootState } from '../types'
import { IAnswerItem, IQuestion } from '../../../types'
import { getGroupQuestion } from '../../../lib/group-question'

export const getters: GetterTree<ExamState, RootState> = {
  // may return null if showing answered all questions
  currentQuestions(state: ExamState): IQuestion<IAnswerItem>[] {
    return getGroupQuestion(state.questions)[state.currentQuestionIndex] ? getGroupQuestion(state.questions)[state.currentQuestionIndex]["questions"] : []
  },

  answeredList(state: ExamState): number[] {
    return state.answers.map((answer) => answer.q_id)
  },

  totalQuestionGroup(state: ExamState): number {
    const group = state.questions.reduce((group: {[keys: number]: any}, question) => {
      group[question.group] = true
      return group
    }, {})
    return Object.keys(group).length
  }
}
